import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
require('../../global/CommonListModal.scss')
import moment from 'moment-timezone'

import Picker from 'react-mobile-picker'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import { getConvertedDate } from '../../utils/helper'



function StartEndDateTime(props) {

    const[pickerDateValue, setPickerDateValue] = useState(null)
    const[btnDisabled, setBtnDisabled] = useState(true)
    
    const { SetstEndCalendar, stEndCalendar, warnCitData, startCal, setIsRateBandSelected } = props
    // const facilityLocData = JSON.parse(localStorage.getItem('faclityData'))
    // let today = moment(new Date(warnCitData?.warning?.updated_at)).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')
    const dtToShow = (stEndCalendar.defaultEndDate && !startCal) ? warnCitData?.warning?.lprExitDetails?.entry_time : (startCal && warnCitData?.warning?.lprDetails) ? warnCitData?.warning?.lprDetails?.entry_time : (startCal && !warnCitData?.warning?.lprDetails && warnCitData?.warning?.lprExitDetails?.entry_time) ? warnCitData?.warning?.lprExitDetails?.entry_time : new Date(getConvertedDate(moment(new Date()).tz(warnCitData?.warning?.facility?.timezone ? warnCitData?.warning?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD HH:mm:ss')))
    let today = moment(new Date(dtToShow)).format('YYYY-MM-DD HH:mm:ss')
    // console.log(dtToShow, 'dtToShow') 

    let nextXDays = function (days) {
        let dayArr = []
        for(let i = 0; i < days; i++) {
            let date = new Date(getConvertedDate(moment(today).add(i, 'days')?.format('YYYY-MM-DD hh:mm:ss')))
            let day = moment(date).format('DD')
            let month = moment(date).format('MMM')
            let year = moment(date).format('YYYY')
            dayArr.push(month +' '+ day + ' yearto ' + year)
            // updatedDate.setDate(updatedDate.getDate() + 1)
        }
        return dayArr
    }
    

    let prevXDays = function (days) {
        let dayArr = []
        for(let i = 0; i < days; i++) {
            let date = new Date(getConvertedDate(moment(today).subtract(i, 'days')?.format('YYYY-MM-DD hh:mm:ss')))
            let day = moment(date).format('DD')
            let month = moment(date).format('MMM')
            let year = moment(date).format('YYYY')
            dayArr.unshift(month +' '+ day + ' yearto ' + year)
            // updatedDate.setDate(updatedDate.getDate() + 1)
        }
        return dayArr
    }

    let days = startCal ? prevXDays(4) : nextXDays(4)

    let hours = function() {
        let hours = []
        for(let i = 1; i <= 12; i++) {
            hours.push(i < 10 ? '0'+i+'' : i+'')
        }
        return hours
    }
    let minutes = function() {
        let min = []
        for(let i = 0; i <= 59; i++) {
            min.push(i < 10 ? '0'+i+'' : i+'')
        }
        return min
    }

    const selections = [
        {mapkey: days, val: 'date'},
        {mapkey: hours(), val: 'hour'},
        {mapkey: minutes(), val: 'minutes'},
        {mapkey: ['AM', 'PM'], val: 'ampm'}
    ]
    
    const [pickerValue, setPickerValue] = useState({
        date: '',
        hour: '',
        minutes: '',
        ampm: '',
    })

    const str = pickerValue.date.replace('yearto ', '')
    moment(str).hours(pickerValue.hour).minutes(pickerValue.minutes).format('MM-DD-YYYY hh:mm')
    const setStringData = (opt) => {
        let strToReturn = opt.split(' yearto ')
        return strToReturn[0]
    }

    useEffect(() => {
        let pickerDtSet = new Date(getConvertedDate(moment(today)?.format('YYYY-MM-DD hh:mm:ss A')))
        // console.log(today, pickerDtSet, 'pickerDtSet')
        setPickerValue({
            date: moment(pickerDtSet).format('MMM') + ' ' + moment(pickerDtSet).format('DD') + ' yearto ' + moment(pickerDtSet).year(),
            hour: moment(pickerDtSet).format('hh'),
            minutes: moment(pickerDtSet).format('mm'),
            ampm: moment(pickerDtSet).format('A'),
        })
    }, [stEndCalendar])

    const handleClick = () => {
        // console.log(pickerDateValue, 'pickerDateValue')
        if(startCal) {
            SetstEndCalendar({...stEndCalendar, start: false, end: false, start_date: pickerDateValue })
        } else {
            SetstEndCalendar({...stEndCalendar, start: false, end: false, end_date: pickerDateValue })
        }
        setIsRateBandSelected(false)
    }

    const handleCustomDatePicker = (e) => {
        setPickerValue(e)
        const dataString = new Date(e.date.split(' yearto ').join(' ').split(' ').join('-'))
        // const currentTimeinSec = moment(new Date(today)).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('ss')
        // const pickerDate = `${e?.date?.includes('Today yearto') ? moment(new Date(today)).tz(facilityLocData?.facility?.timezone ? facilityLocData?.facility?.timezone : 'America/New_York').format('YYYY-MM-DD') : moment(dataString, 'YYYY-MM-DD').format('YYYY-MM-DD')} ${e?.hour}:${e?.minutes}:${currentTimeinSec} ${e?.ampm}`
        const currentTimeinSec = moment(new Date(today)).format('ss')
        const pickerDate = `${e?.date?.includes('Today yearto') ? moment(new Date(today)).format('YYYY-MM-DD') : moment(dataString, 'YYYY-MM-DD').format('YYYY-MM-DD')} ${e?.hour}:${e?.minutes}:${currentTimeinSec} ${e?.ampm}`
        const formattedpickerDate = getConvertedDate(pickerDate)
        setPickerDateValue(formattedpickerDate)
        if(startCal) {
            setBtnDisabled(moment(today).isSameOrBefore(formattedpickerDate, 'minutes'))
        } else {
            setBtnDisabled(moment(today).isSameOrAfter(formattedpickerDate, 'minutes'))
        }
        // console.log(pickerDateValue, formattedpickerDate)
    }

    return (
        <div>
            <Modal show={stEndCalendar.start || stEndCalendar.end} onHide={() => SetstEndCalendar({...stEndCalendar, start: false, end: false })} centered className='commonModalDialogbox' animation={false}>
                <Modal.Header className='justify-content-around'><h5 className='text-primary'>Pick Date & Time</h5></Modal.Header>
                <Modal.Body className='scrollable-Modal'>
                    <Picker wheel="normal" value={pickerValue} onChange={(e) => {
                        handleCustomDatePicker(e)
                    }} option={pickerValue}>
                        {selections.map((name, ind) => (
                            <Picker.Column key={'mapkey_'+ind} name={name.val}>
                                {name['mapkey'].map(option => (
                                    <Picker.Item key={option} value={option}>
                                        {setStringData(option)}
                                    </Picker.Item>
                                ))}
                            </Picker.Column>
                        ))}
                    </Picker>
                </Modal.Body>
                <Modal.Footer className='flex-column'>
                    <h6 className='border w-100 rounded p-2 text-center'><div className='p-1'>
                        Exit By - {`${pickerValue.date.split(' yearto ').join(', ')} ${moment().hour(pickerValue.hour).format('hh')}:${moment().minutes(pickerValue.minutes).format('mm')} ${pickerValue.ampm}`}
                    </div></h6>
                    
                    <button 
                        onClick={handleClick} 
                        disabled={btnDisabled} 
                        className='btn btn-primary w-100 text-white'>Done</button>
                </Modal.Footer>
                {/* <span className='text-danger text-center mb-2' onClick={() => setIsScrollCalendarModal(false)}>Close</span> */}
            </Modal>
        </div>
    )
}

StartEndDateTime.propTypes = {
    SetstEndCalendar: PropTypes.func,
    setIsRateBandSelected: PropTypes.func,
    stEndCalendar: PropTypes.object,
    warnCitData: PropTypes.object,
    startCal: PropTypes.bool,
}

StartEndDateTime.defaulProps = {
    SetstEndCalendar: noop,
    setIsRateBandSelected: noop,
    stEndCalendar: EMPTY_OBJECT,
    warnCitData: EMPTY_OBJECT,
    startCal: false,
}

function mapStateToProps() {
    return {}
}

export default connect(mapStateToProps)(StartEndDateTime)

